// The DLD evidence under an offer card (Backend/services/offerFacts.js), as two
// short lines. Shared by the in-app chat and the public tour chat so both say
// it the same way. Every figure comes from the server; nothing is computed here
// beyond formatting.

export interface OfferFacts {
  available?: boolean;
  askPsf?: number;
  compare?: { scope: 'building' | 'area'; medianPsf: number; comps: number; askVsMedianPct: number } | null;
  rent?: { annual: number; contracts: number; confidence?: string } | null;
  yields?: { grossPct: number | null; netPct: number | null } | null;
}

export interface FactLine { text: string; good?: boolean }

export function offerFactLines(f: OfferFacts | undefined | null, de: boolean): FactLine[] {
  if (!f || !f.available) return [];
  const n = (x: number) => Math.round(x).toLocaleString(de ? 'de-DE' : 'en-AE');
  const p = (x: number) => Math.abs(x).toLocaleString(de ? 'de-DE' : 'en-AE', { maximumFractionDigits: 1 });
  const out: FactLine[] = [];
  const c = f.compare;
  if (c && Number.isFinite(c.askVsMedianPct)) {
    const where = c.scope === 'building'
      ? (de ? 'Gebäude-Median' : 'building median')
      : (de ? 'Gebiets-Median' : 'area median');
    const sales = de ? `${c.comps} Verkäufe` : `${c.comps} sales`;
    if (Math.abs(c.askVsMedianPct) < 1) {
      out.push({ text: de ? `DLD: auf dem ${where} · ${sales}` : `DLD: at the ${where} · ${sales}` });
    } else if (c.askVsMedianPct < 0) {
      out.push({ text: de ? `DLD: ${p(c.askVsMedianPct)} % unter ${where} · ${sales}` : `DLD: ${p(c.askVsMedianPct)}% below ${where} · ${sales}`, good: true });
    } else {
      out.push({ text: de ? `DLD: ${p(c.askVsMedianPct)} % über ${where} · ${sales}` : `DLD: ${p(c.askVsMedianPct)}% above ${where} · ${sales}` });
    }
  }
  if (f.rent && f.rent.annual > 0) {
    const gross = f.yields && f.yields.grossPct != null ? ` · ${p(f.yields.grossPct)}${de ? ' % brutto' : '% gross'}` : '';
    out.push({ text: de ? `DLD-Miete: ${n(f.rent.annual)} AED/Jahr${gross}` : `DLD rent: AED ${n(f.rent.annual)}/yr${gross}` });
  }
  return out;
}
